/* eslint-disable no-underscore-dangle */
import {
  CUSTOM_TYPE_FETCH_SUCCESS,
  CUSTOM_TYPE_FETCH_FAIL,
  CUSTOM_TYPE_FETCH_BY_ID_SUCCESS,
  CUSTOM_TYPE_FETCH_BY_ID_FAIL,
  CUSTOM_TYPE_CREATE_SUCCESS,
  CUSTOM_TYPE_SET_DRAFT,
  CUSTOM_TYPE_DELETE,
  CUSTOM_TYPE_UPDATE_SUCCESS
} from '../constant/actionType';
import logger from '../util/logger';

export const initialState = {
  customTypeDraft: {},
  customTypeStore: {},
  customTypes: [],
  isCustomTypeFailed: false,
  isCustomTypeLoaded: false,
  isFailed: false,
  isLoaded: false
};

const customTypeReducer = (state = initialState, { type, data }) => {
  switch (type) {
    case CUSTOM_TYPE_FETCH_SUCCESS: {
      logger.debug(`${CUSTOM_TYPE_FETCH_SUCCESS}: ${JSON.stringify(data)}`);

      const { customTypes } = data;

      return {
        ...state,
        customTypes,
        isFailed: false,
        isLoaded: true
      };
    }

    case CUSTOM_TYPE_FETCH_FAIL: {
      logger.debug(`${CUSTOM_TYPE_FETCH_FAIL}`);

      return { ...state, isFaled: true, isLoaded: true };
    }

    case CUSTOM_TYPE_FETCH_BY_ID_SUCCESS: {
      logger.debug(`${CUSTOM_TYPE_FETCH_BY_ID_SUCCESS}: ${JSON.stringify(data)}`);

      const { customType } = data;
      const { _id } = customType;

      const customTypeStore = {
        ...state.customTypeStore,
        [_id]: customType
      };

      return {
        ...state,
        customTypeStore: { ...customTypeStore },
        isCustomTypeFailed: false,
        isCustomTypeLoaded: true
      };
    }

    case CUSTOM_TYPE_FETCH_BY_ID_FAIL: {
      logger.debug(`${CUSTOM_TYPE_FETCH_BY_ID_FAIL}`);

      return { ...state, isCustomTypeFailed: true, isCustomTypeLoaded: true };
    }

    case CUSTOM_TYPE_CREATE_SUCCESS: {
      logger.debug(`${CUSTOM_TYPE_CREATE_SUCCESS}: ${JSON.stringify(data)}`);

      const { customType } = data;
      const { customTypes } = state;
      customTypes.unshift(customType);

      return { ...state, customTypes: [...customTypes] };
    }

    case CUSTOM_TYPE_SET_DRAFT: {
      logger.debug(`${CUSTOM_TYPE_SET_DRAFT}: ${JSON.stringify(data)}`);

      const { customTypeDraft, reset, merge } = data;

      let newCustomDraft = {};

      if (!reset) {
        if (merge === false) {
          newCustomDraft = { ...customTypeDraft };
        } else {
          newCustomDraft = { ...state.customTypeDraft, ...customTypeDraft };
        }
      }

      return {
        ...state,
        customTypeDraft: newCustomDraft
      };
    }

    case CUSTOM_TYPE_DELETE: {
      const { customTypes } = data;

      return {
        ...state,
        customTypes
      };
    }

    case CUSTOM_TYPE_UPDATE_SUCCESS: {
      logger.debug(`${CUSTOM_TYPE_UPDATE_SUCCESS}: ${JSON.stringify(data)}`);

      const { customType } = data;
      const customTypes = state.customTypes.map((item) => {
        if (item._id.toString() === customType._id.toString()) {
          return { ...customType };
        }
        return item;
      });

      return { ...state, customTypes: [...customTypes] };
    }

    default:
      return state;
  }
};

export default customTypeReducer;
